import React, { PureComponent } from 'react';

import Icon from '~/core/scripts/components/Icon';
import { getDateOfISOWeek, getWeekRangeDates, getData } from '../utils';
import { sortByKey, numberFormat } from '~/core/scripts/utils';

function getRotation(change) {
  if (change < -0.1) {
    return 'lower';
  }

  if (change > 0.047) {
    return 'higher';
  }

  return '';
}

class LatestWeek extends PureComponent {
  state = {
    isLoading: true,
    numberFormat: {},
    rotation: ''
  };

  componentDidMount() {
    getData().then(data =>
      this.initWidget(data)
    );
  }

  initWidget(data) {
    const sortedData = data
      .map(d => ({
        ...d,
        date: getDateOfISOWeek(d.week, d.year)
      }))
      .sort(sortByKey('date', false));

    const prevData = sortedData[sortedData.length - 2];
    const latestData = sortedData[sortedData.length - 1];
    const weekRange = getWeekRangeDates(latestData.date);
    const percentageChange = (latestData.abs - prevData.abs) / prevData.abs;
    const rotation = getRotation(percentageChange);

    this.setState({
      weekStartLabel: weekRange[0],
      weekEndLabel: weekRange[1],
      latestData,
      rotation,
      isLoading: false
    });
  }

  render() {
    if (this.state.isLoading) {
      return null;
    }

    const { latestData, weekStartLabel, weekEndLabel, rotation } = this.state;

    return (
      <div className="latestweek">
        <div className="latestweek__top">
          <div className="latestweek__label">akuelle Meldewoche</div>

          <div className="latestweek__number-wrapper">
            <div className="latestweek__number">
              {numberFormat(latestData.abs)}
            </div>
            <div className="latestweek__icon">
              <Icon type="big-arrow" className={rotation} />
            </div>
          </div>
        </div>
        <div className="latestweek__subline">
          <strong>Fälle</strong> vom {weekStartLabel} bis {weekEndLabel}
        </div>
      </div>
    );
  }
}

export default LatestWeek;
